class LayoutTemplateProductModalController extends AbstractController
	@register()
	@inject 'product'
